import { useEffect, useState } from 'react';

export default function Sidebar({
  isOpen,
  onClose,
  onOpen,
  children,
  openLabel = 'Info',
}) {
  const [isMobile, setIsMobile] = useState(false);

  // Check if we're on mobile (matches Tailwind's md breakpoint)
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Prevent body scroll when sidebar is open on mobile
  useEffect(() => {
    if (isOpen && isMobile) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen, isMobile]);

  // Don't render anything on desktop
  if (!isMobile) return null;

  const HEADER_HEIGHT = 89;

  return (
    <>
      {/* Open button - shown when sidebar is closed */}
      {!isOpen && onOpen && (
        <button
          onClick={onOpen}
          className="fixed right-0 z-40 bg-primaryblue text-white px-3 py-2 rounded-l-lg shadow-lg"
          style={{ top: HEADER_HEIGHT + 20 }}
          aria-label="Open sidebar"
        >
          <span className="text-sm font-medium">{openLabel}</span>
        </button>
      )}

      {/* Backdrop overlay - starts below header */}
      <div
        className={`fixed inset-x-0 bottom-0 bg-black z-40 transition-opacity duration-300 ${
          isOpen ? 'opacity-50' : 'opacity-0 pointer-events-none'
        }`}
        style={{ top: HEADER_HEIGHT }}
        onClick={onClose}
      />

      {/* Sidebar panel - starts below header */}
      <div
        className={`fixed right-0 bottom-0 w-full max-w-md bg-white z-50 shadow-xl transform transition-transform duration-300 ease-in-out overflow-y-auto ${
          isOpen ? 'translate-x-0' : 'translate-x-full'
        }`}
        style={{ top: HEADER_HEIGHT }}
      >
        {/* Content */}
        <div>{children}</div>
      </div>
    </>
  );
}
